// extracted by mini-css-extract-plugin
export default {"error":"e39c55ab7d80"};